// extracted by mini-css-extract-plugin
module.exports = {"light":"layout-module--light--2N9mU","dark":"layout-module--dark--cOyKg","list":"layout-module--list--1yLp4"};